import { AccordionsInit } from '../accordion'
import { waitAnimationFrame, transitionEnd } from '../../02-tools'
import { createModal } from '../modal'

export function PaletteBuilderInit() {
    const el = document.querySelector('.js-palette-builder')
    if (!el) {
        return
    }

    import('./js/paletteBuilder')
        .then((m) => m.PaletteBuilder)
        .then((PaletteBuilder) => {
            PaletteBuilder(el, waitAnimationFrame, transitionEnd, createModal)
            AccordionsInit(el)
        })
}
